import { Routes } from '@angular/router';

export const complianceRoutes: Routes = [
  {
    path: 'reporting-logs',
    loadComponent: () => import('./reporting-logs/reporting-logs').then((m) => m.ReportingLogs),
    data: { moduleCode: 'rpt_log' }
  },
  {
    path: 'product-logs',
    loadComponent: () => import('./product-logs/product-logs').then((m) => m.ProductLogs),
    data: { moduleCode: 'product_log' }
  },
  {
    path: 'security-logs',
    loadComponent: () => import('./security-logs/security-logs').then((m) => m.SecurityLogs),
    data: { moduleCode: 'sec_log' }
  },
  {
    path: 'api-logs',
    loadComponent: () => import('./api-logs/api-logs').then((m) => m.ApiLogs),
    data: { moduleCode: 'api_log' }
  },
  {
    path: 'transactions-logs',
    loadComponent: () => import('./transactions-logs/transactions-logs').then((m) => m.TransactionsLogs),
    data: { moduleCode: 'trans_log' }
  },
  {
    path: 'operation-logs',
    loadComponent: () => import('./operation-logs/operation-logs').then((m) => m.OperationLogs),
    data: { moduleCode: 'operation_log' }
  },
  {
    path: 'user-audit-trail',
    loadComponent: () => import('./user-audit-trail/user-audit-trail').then((m) => m.UserAuditTrail),
    data: { moduleCode: 'usr_audit_trail' }
  }
];
